import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-search-collapse',
    templateUrl: './search-collapse.component.html',
    styleUrls: ['./search-collapse.component.scss'],
    standalone: false
})
export class SearchCollapseComponent {
  @Input() isEditing: boolean;
  @Output() toggleSearch = new EventEmitter<boolean>();

  private isSearch = false;

  openSearch() {
    this.isSearch = !this.isSearch;
    this.toggleSearch.emit(this.isSearch);
  }
}
